<template>
  <div class="SampleMenu">
    <span class="SampleMenu__icon">
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="pc-layout">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 14.5V1.5H13.5V14.5H1.5ZM0 1C0 0.447715 0.447715 0 1 0H14C14.5523 0 15 0.447715 15 1V15C15 15.5523 14.5523 16 14 16H1C0.447715 16 0 15.5523 0 15V1ZM10.909 5.33386H4.09082V6.83386H10.909V5.33386ZM10.909 9.33276H4.09082V10.8328H10.909V9.33276Z" fill="#1C2A53"/>
      </svg>
    </span>
    <span class="SampleMenu__title">テキスト</span>
    <span class="SampleMenu__icon">
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="pc-layout">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29192 3C4.29192 2.32418 3.73289 1.77515 3.04763 1.77515C2.36107 1.77515 1.80333 2.32544 1.80333 3C1.80333 3.67456 2.36107 4.22485 3.04763 4.22485C3.73418 4.22485 4.29192 3.67582 4.29192 3ZM0 3C0 1.34277 1.36409 0 3.04763 0C4.34999 0 5.46244 0.804801 5.89845 1.93725C6.33411 0.804801 7.44578 0 8.74814 0C10.4317 0 11.7958 1.34404 11.7958 3C11.7958 4.65596 10.433 6 8.74943 6C7.44614 6 6.33429 5.19529 5.89853 4.06293C5.46277 5.19529 4.35092 6 3.04763 6C1.36409 6 0 4.65723 0 3ZM9.99244 3C9.99244 2.32418 9.43341 1.77515 8.74814 1.77515C8.06288 1.77515 7.50385 2.32418 7.50385 3C7.50385 3.67582 8.06159 4.22485 8.74814 4.22485C9.4347 4.22485 9.99244 3.67582 9.99244 3ZM10 7H0.86377V16H10V7ZM14.9999 14.857V8L10.8965 9.3968V13.4602L14.9999 14.857Z" fill="#1C2A53"/>
      </svg>
    </span>
    <span class="SampleMenu__title">動画</span>
    <span class="SampleMenu__icon">
      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="pc-layout">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5002 0C10.3997 0 12.7502 2.35051 12.7502 5.25C12.7502 7.05936 11.8349 8.65493 10.4421 9.59896C12.9766 10.6808 14.7941 13.1181 14.9838 16H12.9778C12.7252 13.1967 10.3692 11 7.5002 11C4.63118 11 2.27524 13.1967 2.02262 16H0.0166016C0.206291 13.1181 2.02381 10.6808 4.55834 9.59896C3.1655 8.65493 2.2502 7.05936 2.2502 5.25C2.2502 2.35051 4.6007 0 7.5002 0ZM7.5002 8.5C9.29513 8.5 10.7502 7.04493 10.7502 5.25C10.7502 3.45507 9.29513 2 7.5002 2C5.70527 2 4.2502 3.45507 4.2502 5.25C4.2502 7.04493 5.70527 8.5 7.5002 8.5Z" fill="#1C2A53"/>
      </svg>
    </span>
    <span class="SampleMenu__title last-child">オーダーメイド</span>
    <span class="SampleMenu__link" @click="onBannerClick">サンプル動画</span>

    <div class="lp-desktopSampleView" :data-visible="isModalVisible">
      <div class="lp-desktopSampleView__close" @click="closeModal">
        <span></span>
        <span></span>
      </div>
      <div class="video-wrap">
        <div class="video-poster" v-if="posterElEnable" @click="onPosterClick">
          <div class="wrap">
            <span class="play-button"></span>
            <span class="time-disp"><span>SAMPLE&nbsp;00:30</span></span>
          </div>
        </div>
        <video
          :src="movieUrl"
          poster="https://uranaitv-town-stg.s3-ap-northeast-1.amazonaws.com/lp/video_letter/performer_sample_thumbnail.jpg"
          class="lp-desktopSampleView__video -normal"
          controls
          playsinline
          controlslist="nodownload"
          @click.prevent = "() => false"
          @ended="onVideoEnded"
        ></video>
      </div>
      <div class="background" @click="closeModal"></div>
    </div>
  </div>
</template>

<script>
export default {
  name:'store-video-sample-menu',
  mounted() {
    this.videoplayer = this.$el.querySelector('video')
    this.posterEl = this.$el.querySelector('.video-poster')
  },
  data() {
    return {
      movieUrl: 'https://uranaitv-town-dev.s3-ap-northeast-1.amazonaws.com/lp/video_letter/performer_sample_movie_30sec.mp4',
      targetUrl: '',
      videoplayer: null,
      posterEl: null,
      posterElEnable: true,
      isModalVisible: false
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    count: {
      type: Number,
      default: 0
    },
    hasThumbnail: { type: Boolean, default: false },
    disablePlaycountApi: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  methods: {
    onBannerClick(e) {
      this.isModalVisible = true
      this.videoplayer.currentTime = 0
      //window.gtag('event', 'Play', { event_category: 'MatatabiDaily', value: (rndNum + 1)})
    },
    onPosterClick(e) {
      this.posterElEnable = false
      this.videoplayer.play()
    },
    closeModal(e) {
      this.videoplayer.currentTime = 0
      this.posterElEnable = true
      this.isModalVisible = false
      this.videoplayer.pause()
    },
    onVideoEnded(e) {
      this.videoplayer.currentTime = 0
      this.posterElEnable = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables/index';

.SampleMenu {
  display: flex;
  flex-direction: row;
  align-content: center;
  color: #000000;
  background: #ffffff;
  padding: 12px 12px;
  border-bottom: 1px solid #ededed;
  &__icon , &__title , &__link {
    font-size: 11px;
    line-height: 14px;
    font-weight: bold;
    @media screen and (min-width: 768px) {
      font-size: 12px;
    }
    @media screen and (min-width: 768px) {
      margin: 1px 4px 0 2px;
      font-size: 16px;
      line-height: 20px;
    }
  }
  &__title {
    margin: 2px 13px 0 4px;
    font-size: 10px;
    @media screen and (min-width: 375px) {
      margin: 1px 8px 0 2px;
      font-size: 12px;
    }
    @media screen and (min-width: 580px) {
      font-size: 16px;
    }
  }

  .last-child {
    margin: 2px 0px 0 4px;
  }

  &__link {
    cursor: pointer;
    margin: 2px 6px 0 6px;
    color: $brand-2;
    text-decoration-line: underline;
    font-weight: normal;
    @media screen and (min-width: 375px) {
      font-size: 12px;
    }
  }

  video {
    position: relative;
    z-index: 100;
  }
  .video-wrap {
    .video-poster {
      height: 397px;
      width: 220px;
      @media screen and (min-width: 375px) {
        height: 437px;
        width: 244px;
      }
      @media screen and (min-width: 580px) {
        height: 655px;
        width: 365px;
      }
      max-width: 400px;
      z-index: 101;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('https://uranaitv-town-stg.s3-ap-northeast-1.amazonaws.com/lp/video_letter/performer_sample_thumbnail.jpg') no-repeat center center;
      background-size: cover;
      margin: auto;
      .wrap {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .time-disp {
        color: white;
        font-size: 14px;
        line-height: 14px;
        background: $brand-2;
        position: absolute;
        right: 5px;
        bottom: 5px;
        z-index: 2;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        span {
          color: white;
          font-size: 14px;
          line-height: 14px;
        }
        &::after {
          content: '';
          width: 14px;
          height: 14px;
          background: url('/static/img/common/play_pink.png') no-repeat;
          background-size: 100%;
          background-position: 50%;
          position: relative;
          display: block;
          margin-left: 4px;
        }
      }
      .play-button {
        height: 48px;
        width: 48px;
        border-radius: 24px;
        border-color: transparent;
        background: hsla(0,0%,100%,.8);
        transition: all 200ms ease-out 0s;
        outline: 0;
        line-height: 1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &::after {
          content: "\F101";
          font-family: VideoJS;
          font-weight: 400;
          font-style: normal;
          font-size: 40px;
        }
      }
      &:hover {
        .play-button {
          background: white;
          cursor: pointer;
        }
      }
    }
  }

  .lp-desktopSampleView__video {
    max-height: 390px;
    @media screen and (min-width: 375px) {
      max-height: 430px;
    }
    @media screen and (min-width: 580px) {
      max-height: 650px;
    }
  }

  .lp-desktopSampleView__close {
    z-index: 102;
  }
  .background {
    width: 100%;
    height: 100%;
    background: transparent;
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
  }
}

.detail__sample {
  width: 67vw;
  @media screen and (min-width: 768px) {
    width: 23vw;
    max-width: 430px;
  }
}

.pc-layout {
  @media screen and (min-width: 768px) {
    width: 20px;
    height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/StoreVideoSampleMenu.vue